/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationShifts200ResponseMondayInner
 */
export interface GetReservationShifts200ResponseMondayInner {
    /**
     * 
     * @type {string}
     * @memberof GetReservationShifts200ResponseMondayInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationShifts200ResponseMondayInner
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationShifts200ResponseMondayInner
     */
    end: string;
}

/**
 * Check if a given object implements the GetReservationShifts200ResponseMondayInner interface.
 */
export function instanceOfGetReservationShifts200ResponseMondayInner(value: object): value is GetReservationShifts200ResponseMondayInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    return true;
}

export function GetReservationShifts200ResponseMondayInnerFromJSON(json: any): GetReservationShifts200ResponseMondayInner {
    return GetReservationShifts200ResponseMondayInnerFromJSONTyped(json, false);
}

export function GetReservationShifts200ResponseMondayInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationShifts200ResponseMondayInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'start': json['start'],
        'end': json['end'],
    };
}

export function GetReservationShifts200ResponseMondayInnerToJSON(json: any): GetReservationShifts200ResponseMondayInner {
    return GetReservationShifts200ResponseMondayInnerToJSONTyped(json, false);
}

export function GetReservationShifts200ResponseMondayInnerToJSONTyped(value?: GetReservationShifts200ResponseMondayInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'start': value['start'],
        'end': value['end'],
    };
}

